export default __webpack_public_path__ + "static/media/Gallery-Icon.f955435f.svg";